export default __webpack_public_path__ + "static/media/babosch4.114fe181.jpg";